import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BasePhotoWrapperComponent } from '@src/app/shared/base-photo';
import { DocumentService } from '@src/core/services';
import { GetImageType } from '@src/models/images';

import { PhotoService } from './services';
import { PhotoInputType } from './types';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoComponent extends BasePhotoWrapperComponent {
  private readonly photoService = inject(PhotoService);
  private readonly documentService = inject(DocumentService);

  @Input({ required: true }) type?: PhotoInputType;
  @Input() unionId?: string;

  override getStorePhotoSrc(id: string, photoSize?: GetImageType): string | undefined {
    // TODO: Подключить store
    return;
  }

  override apiDelete(id: string): Observable<any> {
    switch (this.type) {
      case 'document':
        return this.documentService.deleteDocuments([id])[0];

      case 'photo':
        return this.photoService.deletePhoto(id);

      default:
        return of(null);
    }
  }

  override getPhotoBlob(id: string, photoSize: GetImageType = 'thumbnail'): Observable<Blob | null> {
    switch (this.type) {
      case 'document':
        return this.documentService.downloadDocumentData(id);

      case 'photo':
        return this.photoService.downloadPhotoById(id, photoSize, this.unionId);

      default:
        return of(null);
    }
  }
}
